import replaceCustomShortCodes from '../../utils/replaceCustomShortCodes'
import { SIGNIFICANT_CENTER_COUNT } from '../hero/constants'

const termSpecificHeroCopy = {
  luxury: {
    title: 'Best Luxury Rehabs',
    description: `Our research team evaluated the <a style="text-decoration: underline;" href="#browse-all">[count] best luxury rehabs</a>[location]. Experience one-of-a-kind recovery at unique luxury treatment centers offering high-end amenities, privacy, and comfort. Review our curated list to find luxury rehabs that best meet your recovery needs.`
  },
  'allow cell phones': {
    title: 'Rehabs That Allow Cell Phones',
    description: `<strong>The best rehab is one that meets your needs.</strong> Our research team evaluated the <a style="text-decoration: underline;" href="#browse-all">[count] best rehabs that allow cell phones</a>[location]. Review our curated list of centers providing treatment for addiction and mental health conditions such as depression, anxiety, trauma, and more.`
  },
  'pet friendly': {
    title: 'Pet Friendly Rehabs',
    description: `<strong>The best rehab is one that meets your needs.</strong> Our research team evaluated the <a style="text-decoration: underline;" href="#browse-all">[count] best pet-friendly rehabs</a>[location]. Review our curated list of centers providing treatment for addiction and mental health conditions such as depression, anxiety, trauma, and more.`
  }
}

export const getTermSpecificHeroTitle = (term = '', location) => {
  const copy = termSpecificHeroCopy[term.toLowerCase()]
  if (!copy) return ''

  return location ? copy.title + ` in ${location}` : copy.title
}

export const getTermSpecificHeroDescription = (term, count, location) => {
  if (typeof term !== 'string') {
    return ''
  }

  const descriptionCountReplaced =
    replaceCustomShortCodes({
      originalString:
        termSpecificHeroCopy[term.toLowerCase()]?.description || '',
      count: count > SIGNIFICANT_CENTER_COUNT ? count : '',
      year: '',
      secondaryTerm: ''
    }) || ''

  const descriptionLocationReplaced = descriptionCountReplaced.replace(
    '[location]',
    location ? ` in ${location}` : ''
  )

  return descriptionLocationReplaced
}
